var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcDragIndicator = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a12",
    d: "M3.25 10.5c0 .825-.675 1.5-1.5 1.5s-1.5-.675-1.5-1.5S.925 9 1.75 9s1.5.675 1.5 1.5zm-1.5-6C.925 4.5.25 5.175.25 6s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5zm0-4.5C.925 0 .25.675.25 1.5S.925 3 1.75 3s1.5-.675 1.5-1.5S2.575 0 1.75 0zm4.5 3c.825 0 1.5-.675 1.5-1.5S7.075 0 6.25 0s-1.5.675-1.5 1.5S5.425 3 6.25 3zm0 1.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5zm0 4.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5S7.075 9 6.25 9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(5 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b12",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a12"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#prefix__a12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BEC4CA",
    mask: "url(#prefix__b12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H37.5V37.5H0z",
    transform: "translate(-14.75 -12.75)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDragIndicator, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-drag-indicator.8d624619.svg";
export { ForwardRef as ReactComponent };